import React from "react";

const CustomerModal = ({ open, onClose, customers, handleOpenOrder }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto mx-4">
        {/* Header */}
        <div className="sticky top-0 bg-gradient-to-r from-indigo-600 to-indigo-700 px-6 py-4 flex justify-between items-center rounded-t-xl shadow-md">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
            </svg>
            Customers
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-indigo-100 transition-colors p-1 hover:bg-white/20 rounded-lg"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {customers && customers.length > 0 ? (
            <div className="space-y-3">
              {customers.map((c, index) => {
                const isAutoGenerated =
                  !c.name || /^[0-9]+[A-Z]$/i.test(c.name);
                const label = isAutoGenerated ? "Table" : "Name";
                const displayValue =
                  c.name ||
                  `${c.tableNumber}${String.fromCharCode(65 + index)}`;

                return (
                  <div
                    key={c.id || index}
                    className="border border-gray-200 rounded-lg p-4 flex justify-between items-center gap-3 hover:shadow-md transition-shadow"
                  >
                    <div className="flex-1">
                      <p className="text-sm text-gray-800 mb-1">
                        <span className="font-semibold">{label}:</span>{" "}
                        <span className="font-medium">{displayValue}</span>
                      </p>
                      <p className="text-sm text-gray-600">
                        <span className="font-semibold">Persons:</span>{" "}
                        <span>{c.customerCount}</span>
                      </p>
                    </div>

                    <button
                      onClick={() => handleOpenOrder(c)}
                      className="px-4 py-2 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white text-sm font-medium rounded-lg shadow-md hover:shadow-lg transition-all whitespace-nowrap"
                    >
                      Order
                    </button>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-center text-gray-500 py-8">
              No customer details available
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerModal;
